// extracted by mini-css-extract-plugin
module.exports = {"Title":"Content__Title_2mvs7"};